import { PropsWithChildren } from 'react';

import {
  CSSObject,
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import merge from 'lodash/merge';

import { theme, tokens } from '@cast/design-system';
import { useIsDarkMode } from '@cast/shared-theme-data-access';

import { getRankedTableSx, getRowRankSelector } from 'components/table/utils';
import { MOST_EXPENSIVE_ITEM_COLOR_MAP } from '@cast/constants';
import { rankVariables } from 'constants/theme';

const defaultRankPalette = MOST_EXPENSIVE_ITEM_COLOR_MAP.colorByUsageRank;

const consoleTheme = createTheme(
  merge({}, theme, {
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: tokens.theme.bg.structural.page,
            color: tokens.theme.fg.structural.primary,

            '.tour-active': {
              scrollMarginTop: '300px',
            },

            '.tour-active .tour-highlight': {
              filter: 'drop-shadow(0px 0px 4px rgba(178, 237, 255, 0.6))',
            },

            ...getRankedTableSx(theme, defaultRankPalette),

            ...rankVariables.reduce((acc, name, index) => {
              const selector = `${getRowRankSelector(
                index
              )} > .DS-Table-BodyRow > .DS-Table-CellWrapper:first-of-type:before`;
              acc[selector] = {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '3px',
                backgroundColor: `var(${name})`,
              };
              return acc;
            }, {} as CSSObject),
          },
        },
      },
    },
  })
);

export const ThemeProvider = ({ children }: PropsWithChildren<unknown>) => {
  // Subscribe so jotai-effect keeps data-theme in sync for the full app lifetime.
  useIsDarkMode();

  return <MuiThemeProvider theme={consoleTheme}>{children}</MuiThemeProvider>;
};
